var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rp-messenger-back-button"},[_c('i',{staticClass:"el-icon-back",on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }